import React from 'react';
import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { createFormFieldsByIdGetter } from 'client/helpers/formikHelpers';

import { MEDIA_QUERY_SMALL_SCREEN } from 'client/constants/mediaQueries';

import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrCard from 'client/components/SrCard/SrCard';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';

const SrMarketingItems = ({ formikBag, formFields }) => {
  const isSmallScreen = useMediaQuery({
    query: MEDIA_QUERY_SMALL_SCREEN,
  });

  const getFormFieldsById = createFormFieldsByIdGetter(formFields);
  const onlyRequire3dTour =
    !formikBag.values.requirePhotos && formikBag.values.requireVirtual3dTour;

  const photoFieldsDOM = (
    <>
      <SrFormikField
        formField={getFormFieldsById('availableForPhotoDate')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      <SrFormikField
        formField={getFormFieldsById('availableForPhotoDateSchedule')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      <SrFormikField
        formField={getFormFieldsById('availableForPhotoContactName')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      <SrFormikField
        formField={getFormFieldsById('availableForPhotoContactPhone')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
    </>
  );

  return (
    <SrCard>
      <SrFormikField
        formField={getFormFieldsById('yardSignAllowed')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
        margin="0"
      />
      <SrFormikField
        formField={getFormFieldsById('requireSunlock')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      {getFormFieldsById('requireSunlock').actionLink && (
        <SrBox
          marginTop="15px"
          marginBottom="24px"
          onClick={getFormFieldsById('requireSunlock').actionLink.onClick}
        >
          <SrText
            font="greycliff"
            color="blue300"
            weight="800"
            align={isSmallScreen ? 'center' : null}
            size="16"
            lineHeight="25px"
            cursor="pointer"
            display="block"
          >
            {getFormFieldsById('requireSunlock').actionLink.text}
          </SrText>
        </SrBox>
      )}
      {getFormFieldsById('requireSunlock').additionalComponent}
      {formikBag.values.requireSunlock === false && (
        <SrFormikField
          formField={getFormFieldsById('noRequireSunlockReason')}
          formikBag={formikBag}
          theme={SR_FIELD_THEME_ADOBE}
        />
      )}
      <SrFormikField
        formField={getFormFieldsById('landlordPropertyAccessNotificationAlert')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      {formikBag.values.landlordPropertyAccessNotificationAlert && formikBag.values.requireSunlock && (
        <>
          <SrFormikField
            formField={getFormFieldsById('landlordName')}
            formikBag={formikBag}
            theme={SR_FIELD_THEME_ADOBE}
          />
          <SrFormikField
            formField={getFormFieldsById('landlordPhone')}
            formikBag={formikBag}
            theme={SR_FIELD_THEME_ADOBE}
          />
          <SrFormikField
            formField={getFormFieldsById('landlordEmail')}
            formikBag={formikBag}
            theme={SR_FIELD_THEME_ADOBE}
          />
        </>
      )}
      <SrFormikField
        formField={getFormFieldsById('landlordNotificationAlert')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      {(!formikBag.values.requireSunlock ||
        (formikBag.values.requireSunlock &&
          !formikBag.values.landlordPropertyAccessNotificationAlert)) &&
        formikBag.values.landlordNotificationAlert && (
          <>
            <SrFormikField
              formField={getFormFieldsById('landlordName')}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
            />
            <SrFormikField
              formField={getFormFieldsById('landlordPhone')}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
            />
            <SrFormikField
              formField={getFormFieldsById('landlordEmail')}
              formikBag={formikBag}
              theme={SR_FIELD_THEME_ADOBE}
            />
          </>
        )}
      <SrFormikField
        formField={getFormFieldsById('requirePhotos')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      <SrFormikField
        formField={getFormFieldsById('linkToExistingPhotos')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      {!onlyRequire3dTour && photoFieldsDOM}
      <SrFormikField
        formField={getFormFieldsById('requireVirtual3dTour')}
        formikBag={formikBag}
        theme={SR_FIELD_THEME_ADOBE}
      />
      {onlyRequire3dTour && photoFieldsDOM}
    </SrCard>
  );
};

SrMarketingItems.propTypes = {
  formikBag: PropTypes.object.isRequired,
  formFields: PropTypes.array.isRequired,
};

SrMarketingItems.displayName = 'SrMarketingItems';

export default SrMarketingItems;
